import {AdminApi} from "../../service";
import {BillDto} from "./bill.interface";

export async function getBill(
  billId: string
): Promise<BillDto> {
  return AdminApi.get<BillDto>(`/bills/${billId}`)
    .then(resp => resp.data)
}
